import StoredLayout from '../../../layouts/StoredLayout';
import Home from './Home';
export default StoredLayout(Home);
